import React from "react";
import { Module, ModuleBody } from "@wfp/ui";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

type SummaryCardProps = {
  label: React.ReactNode;
  value: string | number;
  hideValue?: boolean;
  detail?: React.ReactNode;
  latestMonthTag?: string;
  valueColor?: string;
  children?: React.ReactNode;
  onDownloadData?: () => void;
};

const SummaryCard: React.FC<SummaryCardProps> = ({
  label,
  value,
  hideValue,
  detail,
  latestMonthTag,
  valueColor,
  children,
  onDownloadData,
}) => (
  <Module className="dashboard__summary-card">
    <ModuleBody>
      <div className="dashboard__summary-header">
        <h4 className="dashboard__summary-label">{label}</h4>
        {onDownloadData && (
          <button
            type="button"
            className="dashboard__summary-download-link"
            onClick={onDownloadData}
            title="Download data"
          >
            <FontAwesomeIcon
              icon={faDownload}
              className="dashboard__summary-download-icon"
            />
            <FormattedMessage
              id="analytics.dashboard.downloadData"
              defaultMessage="Download data"
            />
          </button>
        )}
      </div>
      {!hideValue && (
        <p
          className="dashboard__summary-value"
          style={valueColor ? { color: valueColor } : undefined}
        >
          {typeof value === "number" ? value.toLocaleString() : value}
          {latestMonthTag ? (
            <span className="dashboard__summary-latest-month-tag">
              {latestMonthTag}
            </span>
          ) : null}
        </p>
      )}
      {detail && <p className="dashboard__summary-detail">{detail}</p>}
      {children && <div className="dashboard__summary-chart">{children}</div>}
    </ModuleBody>
  </Module>
);

export default SummaryCard;
